<template>
  <div>
    <b-modal
      size="xl"
      id="set-filetype-modal"
      :title="$t('Загрузка файла')"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      :hide-header-close="true"
      :ok-disabled="true"
      :cancel-disabled="true"
    >
      <div class="set-filetype-modal">
         <b-row class="mb-3">
           <b-col cols="12" v-if="!newFileTypeVisible">
          <rdkm-select
            :cols="11"
            :labelCols="12" 
            validate="required"
            :name="'fileTypes'"
            :label="$t('Тип файла')"
            v-model="fileType"
            :options="filteredFileTypes">
          </rdkm-select>
            <a href="javascript:void(0)" v-if="!newFileTypeVisible" @click="newFileTypeVisible = true; fileType = ''" :title="$t('Добавить новый тип файла')" class="btn btn-sm btn-primary add-new-file-type">+</a>
          </b-col>
          <b-col cols="12" v-if="newFileTypeVisible">
              <rdkm-input
              :label="$t('Новый тип файла')"
              validate="required"
              name="newFileType"
              :cols="11"
              :labelCols="12"
              v-model="newFileTypeName"
              Edit.vue
            ></rdkm-input>
            <a href="javascript:void(0)" v-if="newFileTypeVisible" @click="newFileTypeVisible = false" :title="$t('Вернуться к выбору существующего типа файла')" class="btn btn-sm btn-primary add-new-file-type">-</a>
          </b-col>
          </b-row>
      </div>
      <div slot="modal-footer" class="w-100">
        <div class="offset-md-3">
          <b-button
            size="sm"
            variant="primary"
            class="mr-4"
            :disabled="errors.count() > 0"
            @click="loadAfterSetType"
          >
            {{ $t('Загрузить') }}
          </b-button>
          <b-button @click="hideModal" size="sm" variant="default">
            <font-awesome-icon icon="times" /> {{ $t('Отмена') }}
          </b-button>
        </div>
        <div class="clearfix"></div>
      </div>
    </b-modal>

    <br />
    <rdkm-select
      :cols="3"
      :labelCols="1" 
      :name="'filterFileTypes'"
      :label="$t('Типы файлов')"
      v-model="fileType"
      :options="filteredFileTypes"
      @input="fetchData"
      style="padding: .75rem;">
    </rdkm-select>
    <div v-show="$refs.upload && $refs.upload.dropActive" class="drop-active">
      <h3>{{ $t('Перетащите сюда файлы для загрузки') }}</h3>
    </div>
    <div class="upload" v-show="!isOption">
      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th>{{ $t('Имя') }}</th>
              <th>{{ $t('Тип') }}</th>
              <th>{{ $t('Размер') }}</th>
              <th>{{ $t('Дата') }}</th>
              <th>{{ $t('Действие') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!files.length">
              <td colspan="7">
                <div class="text-center p-5">
                  <h4>{{ $t('Нет файлов') }}</h4>
                </div>
              </td>
            </tr>
            <tr v-for="file in files" :key="file.id">
              <td>
                <div class="filename">
                  {{ file.name }}
                </div>
                <b-alert v-if="file.error" show variant="danger">{{ file.error }}</b-alert>
                <div
                  class="progress"
                  v-if="
                    (file.active || (file.progress !== '0.00' && file.progress < 100)) && !file.error
                  "
                >
                  <div
                    :class="{
                      'progress-bar': true,
                      'progress-bar-striped': true,
                      'bg-success': file.error,
                      'progress-bar-animated': file.active,
                    }"
                    role="progressbar"
                    :style="{ width: file.progress + '%' }"
                  >
                    {{ file.progress }}%
                  </div>
                </div>
              </td>
              <td>{{ file.fileTypeName }}</td>
              <td>{{ parseInt(file.size / 1024) }} {{ $t('Кб') }}</td>
              <td>{{ formatDate(file.registerDate) }}</td>
              <td>
                <a
                  v-if="file.hash"
                  class="btn btn-secondary btn-sm mr-1"
                  :href="downloadUrl(file.hash)"
                >
                  <i class="fa fa-download"></i>
                  {{ $t('Скачать') }}
                </a>
                <div
                  :key="`${file.id}_create`"
                  v-if="file.hash && !file.isLinkCreated && canCreateLink"
                  class="btn btn-secondary btn-sm mr-1"
                  @click="createUrl(file)"
                  :title="$t('Создать ссылку на файл в системе NextCloud')"
                >
                  <i class="fa fa-link"></i>
                  {{ $t('Создать ссылку') }}
                </div>
                <div
                  :key="`${file.id}_copy`"
                  v-if="file.hash && file.isLinkCreated && canCreateLink"
                  class="btn btn-primary btn-sm mr-1"
                  @click="copyUrlToСlipboard(file.hash)"
                  :title="$t('Скопировать ссылку в буфер обмена')"
                >
                  <i class="fa fa-copy"></i>
                  {{ $t('Скопировать ссылку') }}
                </div>
                <a
                  class="btn btn-danger btn-sm"
                  href="#"
                  v-if="file.hash && canDeleteFile"
                  @click.prevent="removeFile(file)"
                >
                  <i class="fa fa-times"></i>
                  {{ $t('Удалить') }}
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="foorer">
        <div class="btn-group">
          <file-upload
            class="btn btn-primary btn-sm"
            :post-action="postAction"
            :multiple="multiple"
            :directory="directory"
            :size="size || 0"
            :thread="thread < 1 ? 1 : thread > 5 ? 5 : thread"
            :headers="headers"
            :data="data"
            :drop="drop"
            :drop-directory="dropDirectory"
            :add-index="addIndex"
            v-model="files"
            @input-filter="inputFilter"
            @input-file="inputFile"
            input-id="upload"
            ref="upload"
          >
            <i class="fa fa-plus"></i>
            {{ $t('Добавить') }}
          </file-upload>
        </div>
        <!-- <button type="button" class="btn btn-success btn-sm" v-if="!$refs.upload || !$refs.upload.active" @click.prevent="$refs.upload.active = true">
        <i class="fa fa-arrow-up" aria-hidden="true"></i>
        Загрузить
      </button>
      <button type="button" class="btn btn-danger btn-sm"  v-else @click.prevent="$refs.upload.active = false">
        <i class="fa fa-stop" aria-hidden="true"></i>
        Остановить загрузку
      </button> -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import FileUpload from 'vue-upload-component';
import Constants from '../constants';
import { EventBus } from '@/event-bus';
import { mapGetters } from 'vuex';
import { from } from 'rxjs';

export default {
  props: {
    isDataLoaded: false,
    excludedFileTypes: {
        type: Array,
        default: () => []
    },
    entityType: 0,
    path: null,
    businessObjectId: null
  },
  $_veeValidate: {
    validator: 'new'
  },
  provide() {
    return {
      parentValidator: this.$validator,
    };
  },
  components: {
    FileUpload,
  },
  mounted() {
    this.loadFileTypes(false);    
  },
  data() {
    return {
      allFiles: [],
      files: [],
      minSize: 1,
      size: 0,
      multiple: true,
      directory: false,
      drop: false,
      dropDirectory: true,
      addIndex: false,
      thread: 3,
      name: 'file',
      postAction: Constants.baseUrl + '/file',
      headers: {'Authorization': `Bearer ${localStorage['rdkm_auth_token']}`},
      uploadAuto: true,
      isOption: false,
      isMadalVisible: false,
      fileTypes: [],
      fileType: null,
      newFile: '',
      newFileTypeVisible: false,
      newFileTypeName: '',
    };
  },
  methods: {
    userHasFunction(name) {
      return (
        this.$auth.user().functions.find(
          (t) => t.routeName === name
        ) != null
      );
    },
    showModal() {
      this.$root.$emit('bv::show::modal', 'set-filetype-modal');
    },
    hideModal() {
      this.isMadalVisible = false;
      this.newFile = this.fileTypeName = '';
      this.$root.$emit('bv::hide::modal', 'set-filetype-modal');
    },
    loadAfterSetType() {
      this.$validator.validateAll().then((result) => {
        if(result)
        {
          this.isMadalVisible = false;
          this.data['fileTypeId'] = this.fileType;
          this.data['path'] = this.path;
          this.data['fileTypeName'] = this.newFileTypeName;
          this.data['entityType'] = this.entityType;
          this.fetchData();
          this.$refs.upload.add(this.newFile.file);
          this.hideModal();
        }
      });
    },
    loadFileTypes(isFetchData = true) {
      return axios.get(`/Dictionary/GetFileTypes/?type=${this.entityType}`)
      .then((response) => {
        this.fileTypes = response.data;
        let present = false;
        for(var i = 0; i < this.fileTypes.length; i++) {
          if(this.fileTypes[i].key == this.fileType) {
            present = true;
            break;
          }
        }
        if(isFetchData && !present && this.fileType != '') {
          this.fileType = '';
          this.fetchData();
        }
      }); 
    },
    fetchData(setFileTypeToNull = false) {
      if(setFileTypeToNull == true) {
        this.fileType = null;
      }

      this.$refs.upload.clear();
      axios.get(`/file/list/?id=${this.data.id}`).then((response) => {
        this.allFiles = response.data;        
        response.data.filter(t => !this.fileType || t.fileTypeId == this.fileType).map((f) => {
          f.active = false;
          f.hash = f.id;
          f.progress = '0.00';
          f.date = moment(f.registerDate).format('YYYY');
          f.isLinkCreated = f.isLinkCreated;
          for(let i = 0; i< this.fileTypes.length; i++) {
            if(this.fileTypes[i].key == f.fileTypeId)
            f.fileTypeName = this.fileTypes[i].value;
          }
          this.$refs.upload.add(f);
        });

        this.$emit('filesUpdated', this.allFiles);
      });
    },
    formatDate(date) {
      return (date ? moment(date) : moment()).format('DD.MM.YYYY HH:mm:ss');
    },
    downloadUrl(id) {
      return Constants.baseUrl + '/file/' + id;
    },
    async createUrl(file) {
      EventBus.$emit('showThrobber');
      axios
        .get('/file/CreateLink/' + file.hash)
        .then(() => {
          this.$set(file, 'isLinkCreated', true);
        })
        .catch((e) => {
          this.$swal('', e.data.message, 'warning');
        })
        .finally(() => EventBus.$emit('hideThrobber'));
    },
    async copyUrlToСlipboard(id) {
      EventBus.$emit('showThrobber');
      axios
        .get('/file/GetLink/' + id)
        .then((response) => {
          this.$copyText(response.data.linkToNextCloud).then(
            () => {
              this.$swal(
                '',
                this.$t('Ссылка на файл скопирована в буфер обмена'),
                'success'
              );
            },
            () => {
              this.$swal(
                '',
                this.$t('Ошибка при копировании ссылки на файл'),
                'warning'
              );
            }
          );
        })
        .catch((e) => {
          this.$swal('', e.data.message, 'warning');
        })
        .finally(() => {
          EventBus.$emit('hideThrobber');
        });
    },
    removeFile(file) {
      if (file.hash) {
        this.$swal({
          icon: 'warning',
          title: this.$t('Предупреждение'),
          text: this.$t('Вы уверены, что хотите удалить этот файл?'),
          buttons: ['Нет', 'Да'],
        }).then((willDelete) => {
          if (willDelete) {
            EventBus.$emit('showThrobber');
            axios
              .delete('/file?id=' + file.hash)
              .then((response) => {
                this.$refs.upload.remove(file);
                this.allFiles = this.allFiles.filter(f => f.id != file.hash);
                var nextFielInfo = this.allFiles.find(t => t.fileTypeName == file.fileTypeName);
                this.$emit('remove', file.fileTypeName, nextFielInfo);
                this.$emit('filesUpdated', this.allFiles);
                EventBus.$emit('hideThrobber');
                this.loadFileTypes();
              })
              .catch((e) => {
                EventBus.$emit('error', { msg: e.data.message });    
              })
              .finally(() => {
                EventBus.$emit('hideThrobber');
              });
          }
        });
      } else {
        this.$refs.upload.remove(file);
      }
    },
    inputFilter(newFile, oldFile, prevent) {
      if(this.isMadalVisible) {
          return prevent();
      }
      if (newFile && !oldFile) {
        if(newFile.file && (!this.newFile || this.newFile.data.id != newFile.data.id)) {
          this.isMadalVisible = true;
          this.newFileTypeVisible = false;
          this.newFile = newFile;
          this.newFileTypeName = '';
          if(this.entityType == 4 && this.fileType && this.fileType != 'null') {
            this.loadAfterSetType();
          } else {
            this.showModal();
          }
          return prevent();
        }
        // Before adding a file
        // Filter system files or hide files
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }
        // Filter php html js file
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent();
        }
      }
    },
    // add, update, remove File Event
    inputFile(newFile, oldFile) {
      if (newFile && oldFile) {
        // update
        if (newFile.active && !oldFile.active) {
          // min size
          if (
            newFile.size >= 0 &&
            this.minSize > 0 &&
            newFile.size < this.minSize
          ) {
            this.$refs.upload.update(newFile, { error: this.$t('Файл не загружен. Пустой файл.') });
          }
        }
        if(newFile.size > 1024 * 1024 * 10) {
            this.$refs.upload.update(newFile, { error: this.$t('Файл не загружен. Превышен максимальный допустимый размер файла (10 Мб).') });
        }
        if (newFile.success !== oldFile.success) {
          var self = this;
          this.loadFileTypes().then(h => {
            self.fetchData();
          });
          newFile.hash = newFile.response; // success
        }
        if (
          newFile.error &&
          !oldFile.error &&
          newFile.response &&
          newFile.response.message
        ) {
          EventBus.$emit('error', { msg: newFile.response.message });
          this.removeFile(newFile);
        }
      }
      // Automatically activate upload
      if (
        Boolean(newFile) !== Boolean(oldFile) ||
        oldFile.error !== newFile.error
      ) {
        if (this.uploadAuto && !this.$refs.upload.active) {
          this.$refs.upload.active = true;
        }
      }
    },
    showError(message) {
      this.$swal({
        icon: 'error',
        title: this.$t('Ошибка'),
        text: message,
        dangerMode: true,
      });
    },
    // add folader
    onAddFolader() {
      if (!this.$refs.upload.features.directory) {
        this.showError(this.$t('Ваш браузер не поддерживается'));
        return;
      }
      let input = this.$refs.upload.$el.querySelector('input');
      input.directory = true;
      input.webkitdirectory = true;
      this.directory = true;
      input.onclick = null;
      input.click();
      input.onclick = (e) => {
        this.directory = false;
        input.directory = false;
        input.webkitdirectory = false;
      };
    },
    onAddData() {
      this.addData.show = false;
      if (!this.$refs.upload.features.html5) {
        this.showError(this.$t('Ваш браузер не поддерживается'));
        return;
      }
      let file = new window.File([this.addData.content], this.addData.name, {
        type: this.addData.type,
        prepared: true
      });
      this.$refs.upload.add(file);
    },
  },
  computed: {
    filteredFileTypes() {
      return this.fileTypes.filter(f => !this.excludedFileTypes.includes(f.value));
    },
    canDeleteFile() {
      return this.userHasFunction('DeleteFile');
    },
    canCreateLink() {
      return this.userHasFunction('CreateAndGetLinkToNextCloud');
    },
    data() {
      return {id: this.businessObjectId || this.$route.params.id};
    }
  },
  watch: {
    isDataLoaded: function(val) {
      if (val) {
        this.fetchData();
      }
    },
  }
};
</script>

<style scoped>
.uploader-success {
  color: green;
}

.uploader-fail {
  color: red;
}

.uploader-success,
.uploader-fail {
  display: inline-block;
  margin-left: 5px;
}
</style>
